import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../../services/auth';
import { clearAllCaches } from '../../services/generalDataCache';
import './Login.css';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Wait for login to complete
      await login(username, password);
      clearAllCaches();
      
      // Small delay to ensure token is properly stored before navigation
      // This helps prevent race conditions with API calls
      setTimeout(() => {
        navigate('/home');
      }, 100);
    } catch (err) {
      setError(err.message || 'Login failed');
      setLoading(false);
    }
  }, [username, password, navigate]);

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Login</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={loading}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
              required
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default React.memo(Login);
